export default __webpack_public_path__ + "static/media/黃彥男.b919975f.jpg";